import { render, staticRenderFns } from "./partner_examine_detail_base.vue?vue&type=template&id=8c72284e&scoped=true"
import script from "./partner_examine_detail_base.vue?vue&type=script&lang=js"
export * from "./partner_examine_detail_base.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c72284e",
  null
  
)

export default component.exports